export default {
  home: 'خانه',
  profile: 'نمایه',
  user: 'بدون اسم',
  tasks: 'وظیفه‌ها',
  companies: 'شرکت‌ها',
  exit: 'خروج',
  tasksManagement: 'مدیریت وظایف',
  companiesManagement: 'مدیریت شرکت‌ها',
  projectManagement: 'مدیریت پروژه‌ها',
  templateManagement: 'مدیریت قالب‌ها',
  inbox: 'صندوق پیام',
  code: 'کد',

  content: (providerName: string) => {
    if (providerName) {
      return `محتوای ${providerName}`;
    }
    return 'محتوا';
  },
  contentSettings: 'تنظیمات',
  tags: 'برچسب‌ها',
  providerTemplates: 'قالب‌ها',
  login: 'ورود',
  notFound: 'پیدا نشد',
  searchFor(itemName: string | string[] | undefined | null) {
    return `جستجو برای: ${itemName}`;
  },
};

type ProjectRoutes = 'create' | 'editor' | 'members' | 'task' | 'templates';

const routesName: { [name in ProjectRoutes]: string } = {
  create: 'ساخت پروژه جدید',
  editor: 'ویرایش پروژه',
  members: 'اعضای پروژه',
  task: '',
  templates: 'قالب‌های پروژه',
};

export const projectRoutesName = (
  type: ProjectRoutes,
  projectName?: string
) => {
  let title = routesName[type];
  if (projectName) {
    title = `${title} ${projectName}`;
  }
  return title;
};
